<template>
    <k-page>
        <template v-slot:header>
            <registration-header/>
        </template>
        <k-container>
            <rejection-description></rejection-description>
        </k-container>
        <template v-slot:footer>
            <k-footer/>
        </template>
    </k-page>
</template>

<script>
import RegistrationHeader from '@investor/components/registration/RegistrationHeader';
import RejectionDescription from '@investor/components/registration/RejectionDescription';

export default {
        components: {
            RegistrationHeader,
            RejectionDescription
        }
    }
</script>


